<template>
  <div class="PersonForm">
    <h3>{{ $t('form.person.block_name') }}</h3>

    <div v-if="loaded">
      <!--
      <div v-if="autoSave && !hasData">
        <div v-if="allValid" class="alert alert-success" role="alert">
          {{ $t('form.person.all_valid') }}
        </div>
        <div v-else class="alert alert-notice" role="alert">
          {{ $t('form.person.not_valid') }}
        </div>
      </div>
      -->

      <form>
        <div class="form-row">
          <div class="form-item form-item-20" :class="{ hasError: showErrors && !person.sex }">
            <label >{{ $t('form.person.fld_sex') }} *</label>
            <select name="person.sex" v-model="person.sex" required v-on:blur="trySave()">
              <option disabled value='null'>{{ $t('form.person.fld_sex_option_null') }}</option>
              <option value="f">{{ $t('form.person.fld_sex_option_f') }}</option>
              <option value="m">{{ $t('form.person.fld_sex_option_m') }}</option>
            </select>
          </div>
          <div class="form-item form-item-40" :class="{ hasError: showErrors && !person.firstname }">
            <label>{{ $t('form.person.fld_firstname') }} *</label>
            <input name="person.firstname" type="text" v-model="person.firstname" required v-on:blur="trySave()"/>
          </div>
          <div class="form-item form-item-40" :class="{ hasError: showErrors && !person.lastname }">
            <label>{{ $t('form.person.fld_lastname') }} *</label>
            <input name="person.lastname" type="text" v-model="person.lastname" required v-on:blur="trySave()" />
          </div>
        </div>

        <BirthdateField v-model="person.birthdate" type="person" :error="birthdateError" v-on:input="trySave()"  :class="{ hasError: showErrors && !person.birthdate }"/>

        <div v-if="!autoSave" id="submitOrBusy">
          <img v-if="axiosBusy" src="static/letsfamily-de/img/spinner.svg"/>
          <button class="btn btn-red mb-2" v-else-if="!allValid" disabled>
            {{ $t('form.generic.btn_form_invalid') }}
            </button>
          <button class="btn btn-green mb-2" v-else
            v-on:click.prevent="updPerson()" >{{ $t('form.generic.btn_save') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getPerson, updatePerson } from "@/api/person.js";
import { mapGetters } from "vuex";
import BirthdateField from "@/snippets/BirthdateField.vue";
import { parseISO, isBefore, subYears } from "date-fns";

export default {
  name: "PersonForm",
  props: {
    autoSave: {
      type: Boolean,
      default: true
    },
    showErrors: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      person: {},
      loaded: false,
      hasData: false
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy"
    }),
    allValid() {
      if (this.hasAllRequired && this.birthdateValid) {
        return true;
      } else {
        return false;
      }
    },
    hasAllRequired() {
      if (
        this.person.sex &&
        this.person.birthdate &&
        this.person.firstname &&
        this.person.lastname
      ) {
        return true;
      } else {
        return false;
      }
    },
    birthdateError() {
      if (this.person.birthdate === null) {
        // no date yet, so don't check for errors
        return false;
      }
      if (this.person.birthdate) {
        const bd = parseISO(this.person.birthdate);
        if (isBefore(subYears(new Date(), 16), bd)) {
          return "person_too_young";
        }
        if (isBefore(bd, subYears(new Date(), 100))) {
          return "person_too_old";
        }
        return false;
      } else {
        return "invalid";
      }
    },
    birthdateValid() {
      return this.birthdateError ? false : true;
    }
  },
  created() {
    this.fetchData();
  },
  async beforeDestroy() {
    await this.trySave();
  },
  methods: {
    async fetchData() {
      const rv = await getPerson(this.$userClient);
      if (rv) {
        this.person = rv.person;
        this.loaded = true;
        this.hasData = this.allValid;
      }
    },
    async trySave() {
      if (this.autoSave && this.allValid) {
        await this.updPerson();
      }
    },
    async updPerson() {
      const rv = await updatePerson(this.$userClient, this.person);
      if (rv) {
        this.person = rv.person;
        this.$emit("user-data-updated", {subform:"person", "return": rv});
      }
    }
  },
  components: {
    BirthdateField
  }
};
</script>
